import { Group, Paper, Pill, Stack, Text } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { TitleCard } from '@/core/components';

import { LanguagePill } from '@feature/utils';

import { Citation } from '../../model/CitationTypes';
import classes from './CitationCard.module.css';

export interface CitationCardProps {
  citation: Citation;
  to?: string;
  onClick?: () => void;
}

export function CitationCard({ citation, to, onClick }: CitationCardProps) {
  const { title, journal, publisher } = citation;
  const { t } = useTranslation();
  return (
    <Paper
      className={classes.card}
      component={to ? Link : undefined}
      onClick={onClick}
      to={to}
      p="lg"
      c="var(--mantine-color-text)"
    >
      <Stack gap="xs">
        <TitleCard title={title} />
        <Pill>{t(`citations.prestigeEnum.${citation.citationPrestige}`)}</Pill>
        <Group>
          {journal && <Text>{journal.title}</Text>}
          {publisher && <Text>{publisher.title}</Text>}
        </Group>
        <Group>
          <Text size="sm">{citation.noOfAuthors} autori</Text>
        </Group>
        <Group>
          {journal?.language?.name && <LanguagePill language={journal.language} />}
          <Text
            size="sm"
            c="dimmed"
          >
            <Pill>{citation.citationDate.year}</Pill>
          </Text>
        </Group>
      </Stack>
    </Paper>
  );
}
